import { Task, Timestamp, WeekDays } from '@griply/types';

import { getTaskDueAndTimeslot } from './get-task-due-and-timeslot';

export type GetTaskDueDateOptions = {
  today: Timestamp;
  weekStartsOn: WeekDays;
};

export const getTaskDueDate = (
  task: Task,
  { today, weekStartsOn }: GetTaskDueDateOptions,
) => getTaskDueAndTimeslot(task, { today, weekStartsOn }).dueDate;
